<template>
  <div class="personal-container">
    <Header title="个人中心" />
    <div class="personal-inner">
      <el-card shadow="never">
        <template slot="header">
          <b>基本信息</b>
        </template>
        <div class="content">
          <el-upload class="avatar-uploader" :data-user="['学生', '家长', '教职工', '管理员'][userInfo.userDict]" action="#"
            :http-request="requestUpload" :before-upload="beforeUpload" :show-file-list="false">
            <img :src="userInfo.headUrl ? baseUrl + userInfo.headUrl : require('../../assets/avatar.jpg')" width="150">
          </el-upload>
          <el-form size="medium" label-width="85px">
            <el-form-item label="用户名：">{{ userInfo.name }}</el-form-item>
            <el-form-item label="登录名：" prop="loginName">{{ userInfo.loginName }}</el-form-item>
            <el-form-item label="性别：" prop="gender">{{ ['女', '男'][userInfo.gender] }}</el-form-item>
            <el-form-item label="显示名：" prop="displayName">{{ userInfo.displayName }}</el-form-item>
            <el-form-item label="手机号：">{{ userInfo.mobilePhone }}</el-form-item>
            <el-form-item label="身份证号：">{{ userInfo.cardNum }}</el-form-item>
          </el-form>
        </div>
      </el-card>

      <el-card shadow="never">
        <template slot="header">
          <b>账号密码</b>
          <i class="el-icon-warning-outline"></i>
          <span>如忘记原始密码，请联系管理员重置密码</span>
        </template>
        <div class="content">
          <el-form :model="form" :rules="rules" ref="passwordForm">
            <el-form-item label="原始密码" prop="password">
              <el-input size="medium" type="password" show-password v-model="form.password"></el-input>
            </el-form-item>
            <el-form-item label="新密码" prop="newPassword">
              <el-input size="medium" type="password" show-password v-model="form.newPassword"></el-input>
            </el-form-item>
            <el-form-item label="确认新密码" prop="confirmPassword">
              <el-input size="medium" type="password" show-password v-model="form.confirmPassword"></el-input>
            </el-form-item>
          </el-form>
        </div>
        <el-button type="primary" @click="confirm('password')">确认修改</el-button>
      </el-card>
    </div>
    <Footer />

    <el-dialog :visible.sync="dialogVisible" title="头像裁剪">
      <div class="cropper flex-column">
        <vueCropper ref="cropper" :img="option.img" :info="option.info" :outputType="option.outputType"
          :autoCrop="option.autoCrop" :canMove="option.canMove" :autoCropWidth="option.autoCropWidth"
          :autoCropHeight="option.autoCropHeight" :fixedBox="option.fixedBox" :centerBox="option.centerBox"
          @realTime="realTime" />
        <div class="tool">
          <el-button size="mini" icon="el-icon-refresh-left" @click="rotateLeft"></el-button>
          <el-button size="mini" icon="el-icon-refresh-right" @click="rotateRight"></el-button>
          <el-button size="mini" icon="el-icon-zoom-out" @click="changeScale(-1)"></el-button>
          <el-button size="mini" icon="el-icon-zoom-in" @click="changeScale(1)"></el-button>
        </div>
      </div>
      <div class="preview flex-column">
        <div class="square">
          <img :src="previews.url" :style="previews.img" alt="">
        </div>
        <div class="circle">
          <img :src="previews.url" :style="previews.img" alt="">
        </div>
      </div>
      <span slot="footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="upload">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import * as api from './api'
import { getConfigInfo } from '../login/api'
import md5 from '@/utils/md5'
export default {
  name: 'Personal',
  components: {
    Header: () => import('../../components/Header'),
    Footer: () => import('../../components/Footer'),
  },
  data() {
    var validateConfirmPassword = (rule, value, callback) => {
      if (value) {
        if (value === this.form.newPassword) {
          callback()
        } else {
          callback(new Error('两次输入的密码不一致'))
        }
      } else {
        callback(new Error('请输入确认密码'))
      }
      callback()
    }
    return {
      baseUrl: localStorage.getItem('baseUrl'),
      uploadParams: { token: localStorage.getItem('sys_token') },
      userInfo: JSON.parse(localStorage.getItem('userInfo')),
      dialogVisible: false,
      option: {
        img: '', // 裁剪图片的地址
        info: false, // 裁剪框的大小信息
        outputType: 'png', // 裁剪生成图片的格式
        autoCrop: true, // 是否默认生成截图框
        canMove: false, // 上传图片是否可以移动
        autoCropWidth: 200, // 默认生成截图框宽度
        autoCropHeight: 200, // 默认生成截图框高度
        fixedBox: true, // 固定截图框大小 不允许改变
        centerBox: true, // 截图框是否被限制在图片里面
      },
      previews: {},
      form: {
        password: '',
        newPassword: '',
        confirmPassword: ''
      },
      rules: {
        password: [{ required: true, message: '请输入原始密码', trigger: 'change' }],
        newPassword: [{ required: true, message: '请输入新密码', trigger: 'change' }],
        confirmPassword: [{ required: true, validator: validateConfirmPassword, trigger: 'change' }]
      }
    }
  },
  async created() {
    const { data: { settingValue, settingDescription } } = await getConfigInfo('psd_regex')
    const regex = new RegExp(settingValue)
    this.rules.newPassword.push({
      validator: (rule, value, callback) => {
        if (!value) return callback()
        if (regex.test(value)) callback()
        else callback(new Error(settingDescription))
      },
      trigger: 'change'
    })
  },
  methods: {
    beforeUpload(file) {
      if (file.type !== 'image/jpeg' && file.type !== 'image/png')
        return this.$message.error('上传头像图片只能是 JPG/PNG 格式!')
      if (file.size / 1024 / 1024 > 2)
        return this.$message.error('上传头像图片大小不能超过 2MB!')
      const reader = new FileReader()
      reader.readAsDataURL(file)
      reader.onload = () => {
        this.option.img = reader.result
        this.loading = false
        this.dialogVisible = true
      }
    },
    requestUpload() { },
    upload() {
      this.$refs.cropper.getCropBlob(async data => {
        const file = new window.File([data], this.userInfo.name + '.png', { type: 'image/png' })
        const formData = new FormData()
        formData.append('file', file)
        formData.append("code", md5(file.size))
        const { data: { filePath } } = await api.upload(formData)
        this.userInfo.headUrl = filePath
        await api.updateUserInfo(this.userInfo)
        this.$message.success('头像已修改')
        this.dialogVisible = false
        window.location.reload()
      })
    },
    realTime(data) {
      this.previews = data
    },
    rotateLeft() {
      this.$refs.cropper.rotateLeft()
    },
    rotateRight() {
      this.$refs.cropper.rotateRight()
    },
    changeScale(num) {
      num = num || 1
      this.$refs.cropper.changeScale(num)
    },
    confirm() {
      this.$refs.passwordForm.validate(async valid => {
        if (valid) {
          await api.updatePassword(this.form)
          this.$message.success('密码已修改')
          this.$refs.form.resetFields()
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.personal-container {
  background: #f9fbfc;

  .personal-inner {
    height: 100vh;
    min-height: 100vh;
    width: var(--inner-width);
    margin: auto;
    padding: 100px 0 50px;
    display: flex;
    gap: 100px;

    ::v-deep.el-card {
      height: 100%;

      &__header {
        b {
          font-size: 18px;
        }

        i {
          font-size: 12px;
          margin: 0 3px 0 20px;
          color: #888;
        }

        span {
          font-size: 12px;
          color: #888;
        }
      }

      .content {
        display: flex;
        gap: 50px;
        padding: 20px 50px;

        .el-form {
          width: 300px;
        }
      }

      .avatar-uploader .el-upload {
        position: relative;
        height: 150px;
        overflow: hidden;

        &:hover::before {
          opacity: 1;
        }

        &::before {
          content: '更换头像';
          font-size: 13px;
          color: #fff;
          opacity: 0;
          inset: 0;
          background: #00000080;
          position: absolute;
          line-height: 150px;
          text-align: center;
          transition: 300ms;
        }
      }

      .avatar-uploader {
        position: relative;
        height: 150px;

        &::before {
          content: attr(data-user);
          font-size: 12px;
          font-weight: bold;
          position: absolute;
          bottom: -32px;
          left: 50%;
          transform: translateX(-50%);
          border: 1px solid #ddd;
          padding: 4px 10px;
          color: #888;
          background: #eee;
          border-radius: 2px;
        }
      }


      .el-input {
        width: 300px;
      }

      .el-button {
        float: right;
        width: 300px;
        margin-right: 50px;
      }
    }
  }

  ::v-deep.el-dialog__body {
    display: flex;
    justify-content: center;
    align-items: flex-start;
    gap: 50px;

    .cropper {
      width: 600px;
      height: 450px;
      gap: 10px;
    }

    .preview {
      gap: 50px;

      div {
        width: 180px;
        height: 180px;
        overflow: hidden;

        img {
          width: 100%;
          height: 100%;
        }

        &.circle {
          border-radius: 50%;
        }
      }
    }
  }
}
</style>